import { style, media } from "typestyle";
import { colors, queries } from "styles/styles";

export const container = style(
  {
    alignSelf: "center",
    width: "100%",
    padding: "0rem 1rem",
    borderBottom: `1px solid ${colors.hooplaBorderColor}`,
  },
  // Padding to account for scrollbar
  media(queries.medium, {
    padding:
      "0rem calc((100% - 48rem - (100vw - 100%)) / 2) 0rem calc((100% - 48rem  + (100vw - 100%)) / 2)",
  }),
  media(queries.large, {
    padding:
      "0rem calc((100% - 65rem - (100vw - 100%)) / 2) 0rem calc((100% - 65rem + (100vw - 100%)) / 2)",
  }),
);

export const topbar = style(
  {
    display: "flex",
    alignItems: "center",
    padding: "1rem",
    backgroundColor: colors.hooplaWhite,
    borderBottom: `1px solid ${colors.hooplaBorderColor}`,
  },
  // Padding to account for scrollbar
  media(queries.medium, {
    padding:
      "1rem calc((100% - 48rem - (100vw - 100%)) / 2) 1rem calc((100% - 48rem  + (100vw - 100%)) / 2)",
  }),
  media(queries.large, {
    padding:
      "1rem calc((100% - 65rem - (100vw - 100%)) / 2) 1rem calc((100% - 65rem + (100vw - 100%)) / 2)",
  }),
);

export const logoWrapper = style({
  display: "flex",
  flex: 1,
});

export const logo = style({
  width: 90,
});

export const link = style(
  {
    display: "none",
    stroke: colors.hooplaTextColor120,
    fill: colors.hooplaTextColor120,
    color: colors.hooplaTextColor120,
    transition: "all 0.1s linear",

    $nest: {
      "&:hover": {
        color: colors.hooplaTextColorTinted,
        stroke: colors.hooplaTextColorTinted,
        fill: colors.hooplaTextColorTinted,
      },
    },
  },
  media(queries.medium, {
    cursor: "pointer",
    fontSize: "1rem",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    marginLeft: "2rem",
  }),
);
